<template>
  <div class="setup-account-page">
    <div class="setup-container">
      <div class="setup-card">
        <div class="setup-header">
          <h1>Account Setup</h1>
          <p>Complete your account setup by creating a password</p>
        </div>
        
        <form @submit.prevent="setupAccount" class="setup-form">
          <div class="form-group">
            <label>Email:</label>
            <input v-model="email" type="email" readonly class="readonly-input">
          </div>
          
          <div class="form-group">
            <label>Name:</label>
            <input v-model="name" type="text" readonly class="readonly-input">
          </div>
          
          <div class="form-group">
            <label>New Password:</label>
            <input v-model="password" type="password" required minlength="6">
          </div>
          
          <div class="form-group">
            <label>Confirm Password:</label>
            <input v-model="confirmPassword" type="password" required minlength="6">
          </div>
          
          <button type="submit" class="setup-btn" :disabled="loading">
            {{ loading ? 'Setting up...' : 'Complete Setup' }}
          </button>
        </form>
        
        <div v-if="message" class="message" :class="messageType">
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      name: '',
      password: '',
      confirmPassword: '',
      token: '',
      loading: false,
      message: '',
      messageType: ''
    }
  },
  methods: {
    async setupAccount() {
      if (this.password !== this.confirmPassword) {
        this.showMessage('Passwords do not match', 'error')
        return
      }
      
      if (this.password.length < 6) {
        this.showMessage('Password must be at least 6 characters', 'error')
        return
      }
      
      this.loading = true
      
      try {
        const response = await fetch('/api/setup-account', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token: this.token,
            password: this.password
          })
        })
        
        const result = await response.json()
        
        if (response.ok) {
          this.showMessage('Account setup completed successfully! You can now login.', 'success')
          setTimeout(() => {
            this.$router.push('/login')
          }, 2000)
        } else {
          this.showMessage(result.error || 'Setup failed', 'error')
        }
      } catch (error) {
        this.showMessage('Network error occurred', 'error')
      }
      
      this.loading = false
    },
    
    async verifyToken() {
      try {
        const response = await fetch(`/api/verify-setup-token?token=${this.token}`)
        const result = await response.json()
        
        if (response.ok) {
          this.email = result.email
          this.name = result.name
        } else {
          this.showMessage('Invalid or expired setup link', 'error')
        }
      } catch (error) {
        this.showMessage('Failed to verify setup link', 'error')
      }
    },
    
    showMessage(text, type) {
      this.message = text
      this.messageType = type
      setTimeout(() => {
        this.message = ''
      }, 5000)
    }
  },
  
  mounted() {
    this.token = this.$route.query.token
    if (this.token) {
      this.verifyToken()
    } else {
      this.showMessage('Invalid setup link', 'error')
    }
  }
}
</script>

<style scoped>
.setup-account-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.setup-container {
  width: 100%;
  max-width: 400px;
}

.setup-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.setup-header {
  text-align: center;
  margin-bottom: 2rem;
}

.setup-header h1 {
  color: #1e3a8a;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.setup-header p {
  color: #6b7280;
  font-size: 0.9rem;
}

.setup-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #1e3a8a;
  font-size: 0.9rem;
}

.form-group input {
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #1e3a8a;
}

.readonly-input {
  background: #f8fafc;
  color: #6b7280;
}

.setup-btn {
  background: #1e3a8a;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 1rem;
}

.setup-btn:hover:not(:disabled) {
  background: #1e40af;
  transform: translateY(-1px);
}

.setup-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.message {
  margin-top: 1rem;
  padding: 0.75rem;
  border-radius: 6px;
  font-size: 0.9rem;
  text-align: center;
}

.message.success {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.message.error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

@media (max-width: 480px) {
  .setup-account-page {
    padding: 1rem;
  }
  
  .setup-card {
    padding: 1.5rem;
  }
  
  .setup-header h1 {
    font-size: 1.5rem;
  }
}
</style>